export default __webpack_public_path__ + "static/media/regulatory--end-of-bus-and-taxi-only--g1.95ed8ca1.png";